export default {
  type: "labels",
  category: null,
  slug: "",
  name_translate: [],
  excerpt_translate: [],
  relationshipNames: [],
};
